<template>
  <div>
    <progressLinear
      :color="`${!education.isActive ? 'grey' : 'light-blue'}`"
      :value="getPercentage(Number(education.bookElementsApprovedCount), Number(education.bookElementsMandatoryCount))"
    />

    <p class="ligth-grey" v-if="!education.isActive"
      v-html="
        $t('basicEducation.basic-education-period-inactive', {
          proffession: getProfessionNameById(education.professionId),
          start: $options.filters.date(education.createdAt)
        })
      "
    ></p>

    <p v-else
      v-html="
        $t('basicEducation.basic-education-period-alt2', {
          profession: getProfessionNameById(get(education, 'professionId', null)),
          start: $options.filters.date(education.createdAt),
          end: $options.filters.date(education.education.calculatedEndDate),
          instructors: instructorNames,
          companyName
        })
      "
    ></p>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Utilities} from '@/components/mixins'
import progressLinear from '@/components/Common/ProgressLinear'
import get from 'lodash/get'

export default {
  name: 'BasicEducationTimeItem',
  components: {
    progressLinear
  },
  mixins: [Utilities],
  props: {
    education: Object,

    instructors: {
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    ...mapGetters('basic', ['getProfessionNameById']),
    ...mapGetters('currentuser', ['currentUser']),
    
    instructorNames() {
      return this.instructors.map(o => `${ get(o, 'employed.firstName', '') } ${ get(o, 'employed.lastName', '') }`).join(', ')
    },

    companyName() {
      if ( get(this, '$route.params.id', null) )
        return get(this, 'currentUser.employments', [])
        .find(({ companyId }) => Number(get(this, '$route.params.id', '')) === companyId)?.company?.name

      return get(this, 'currentUser.employments', [])
        .find(({ companyId }) => get(this, 'education.education.apprenticeships', [])
        .find(apprenticeship => apprenticeship.companyId === companyId))?.company?.name
    }
  },
  methods: {
    get,

    getTimePercentage(start, end) {
      const startDate = new Date(start)
      const endDate = new Date(end)
      const nowDate = new Date()
      const totalTime = endDate - startDate
      const passedTime = nowDate - startDate

      return this.getPercentage(passedTime, totalTime)
    }
  }
}
</script>

<style>
</style>